import Entity from './entity';
export default Entity.extend({
  ignoreContentsWhenSerializing: true,
  precedence: 0,
  type: 'marker',
  tagName: 'ic-marker',
  additionalAttributes: 'class="entity_marker loader" contenteditable="false"',
  attributesToCopy: ['startIndex', 'endIndex', 'options'],
  openingHtmlForSerialized: '',
  closingHtmlForSerialized: '',
  options: {},
  updateForDelete(block, deletedBlockRange) {
    let delta = deletedBlockRange.get('length');
    if (this.isAdjacentRightOfRange(deletedBlockRange)) {
      this.shiftLeftBy(delta);
      return;
    }
    if (this.containedIn(deletedBlockRange) || this.isExactRange(deletedBlockRange)) {
      this.empty();
      return;
    }
    if (this.intersectsLeft(deletedBlockRange)) {
      this.set('allowEmpty', false);
      deletedBlockRange.shiftRightBy(1);
      this.empty();
      return;
    }
    if (this.intersectsRight(deletedBlockRange)) {
      this.set('allowEmpty', false);
      deletedBlockRange.shiftRightBy(1);
      this.empty();
      return;
    }
  }
}).reopenClass({
  tagName: 'I'
});